import { Component, ViewChild, ElementRef } from "@angular/core";
import { GlobalConstants } from "../common/global-constants";
import { PokemonService } from "./../services/pokemon.service";
import { IonSlides } from "@ionic/angular";
import { Footermobile } from "../common/footermobile";
import { Title, Meta } from "@angular/platform-browser";
import { ActivatedRoute, Router, NavigationExtras } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ModalPopupPage } from "../modal-popup/modal-popup.page";
import { IframePage } from "../iframe/iframe.page";
import { ModalController } from "@ionic/angular";
import * as moment from "moment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
} from "swiper/core";

// install Swiper components
SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
]);

@Component({
  selector: "app-home",
  templateUrl: "home.page.html",
  styleUrls: ["home.page.scss"],
})
export class HomePage {
  offset = 0;
  mobil:any = [];
  location:any = [];
  alllocation:any = [];
  locationgroup:any;
  pokemon = [];
  special = [];
  country = [];
  komen = [];
  data: any;
  url: any;
  mySlider: any;
  mySliderkomen: any;
  safeSrc: SafeResourceUrl;
  //swiper config
  breakpoints = {
    0: { slidesPerView: 2, spaceBetween: 5 },
    760: { slidesPerView: 3, spaceBetween: 8 },
    1024: { slidesPerView: 3, spaceBetween: 10 },
    1440: { slidesPerView: 3, spaceBetween: 10 },
  };
  footer = GlobalConstants.sitefooter;
  footermobile = Footermobile.sitefootermobile;

  @ViewChild("mySliderkomen") slides: IonSlides;

  swipeNext() {
    this.slides.slideNext();
  }
  swipePrev() {
    this.slides.slidePrev();
  }
  /*
  showhide(){
   
    var x = document.getElementById("show");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
  }
  */
  //bookingvar
  booklocation: any;
  Age: any;
  bookdata: any;
  bookurl: any;

  step1m = {
    country: "au",
    pickuploc: "",
    pickupdate: "",
    pickuptime: "",
    dropoffloc: "",
    dropoffdate: "",
    dropofftime: "",
    voucher: "",
    age: "",
  };
  agexx = 0;
  alldata = 1;
  dateverify = 1;

  PickupOptions: any = {
    Header: "Select Pickup Location",
    cssClass: "action-sheet-height",
  };
  DropoffOptions: any = {
    Header: "Select Dropoff Location",
    cssClass: "action-sheet-height",
  };

  datedesktop = [];
  public minDate = moment().add(1, "d").format();
  public maxDate = moment().add(5, "y").format();

  dayx = new Date();

  public mindateDS = moment(this.dayx.setHours(10, 0, 0)).format();
  public maxdateDS = moment(this.dayx.setHours(16, 30, 0)).format();
  defloc: boolean = false;
  deflocval = "";
  compareWith: any;

  constructor(
    private pokeService: PokemonService,
    private titleService: Title,
    private meta: Meta,
    private route: ActivatedRoute,
    public router: Router,
    private metaService: Meta,
    public modalController: ModalController,
    private sanitizer: DomSanitizer,
    { nativeElement }: ElementRef<HTMLImageElement>
  ) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://cdn.lightwidget.com/widgets/fb1c440dcfd15401995a0c381f8a7626.html"
    );
    sessionStorage.removeItem("step3session");
    sessionStorage.removeItem("bookingrefdata");
    this.route.queryParams.subscribe((params) => {
      if (params["refid"] != null) {
        sessionStorage.setItem("refid", params["refid"]);
        console.log("refid:" + sessionStorage.getItem("refid"));
      }
      if (params["location"] != null) {
        this.defloc = true;
        this.deflocval = params["location"];
      }
    });

    const supports = "loading" in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute("loading", "lazy");
    } else {
      // fallback to IntersectionObserver
    }
  }

  doRefresh(event) {
    console.log("Begin async operation");

    setTimeout(() => {
      console.log("Async operation has ended");
      event.target.complete();
    }, 2000);
  }

  ngOnInit() {
    this.loadPokemon();
    this.titleService.setTitle("ᑕ❶ᑐ Cheap Campervan hire - wickedcampers.com");
    this.metaService.updateTag({
      name: "description",
      content:
        "Find your perfect Campervan hire and hit the road, book online or call our road trip planners and we Will get you on your way, Easily browse all our vehicles and locations, find your ideal ride and get an instant quote now.",
    });
    //this.metaService.updateTag( { rel: 'canonical', href: 'https://wickedcampers.com' } );
    this.pokeService.setLinkRel("https://www.wickedcampers.com", "canonical");
    // Twitter
    this.metaService.updateTag({
      name: "twitter:card",
      content: "summary_large_image",
    });
    this.metaService.updateTag({
      name: "twitter:site",
      content: "@wickedcampers",
    });
    this.metaService.updateTag({
      name: "twitter:site:id",
      content: "@wickedcampers",
    });
    this.metaService.updateTag({
      name: "twitter:creator",
      content: "@wickedcampers",
    });
    this.metaService.updateTag({
      name: "twitter:url",
      content: "https://www.wickedcampers.com",
    });
    this.metaService.updateTag({
      name: "twitter:title",
      content: "Cheap Campervan Hire - Wicked Campers",
    });
    this.metaService.updateTag({
      name: "twitter:description",
      content:
        "We offer Wicked campervan hire for budget traveller looking for a cheap and easy way of exploring World Wide.",
    });
    this.metaService.updateTag({
      name: "twitter:image:src",
      content:
        "https://cdn.wickedcampers.com/nz/specials/whistler-special.jpg",
    });
    // Facebook

    this.metaService.updateTag({
      property: "og:title",
      content: "Cheap Campervan Hire - Wicked Campers",
    });
    this.metaService.updateTag({ property: "og:type", content: "website" });
    this.metaService.updateTag({
      property: "og:image",
      content:
        "https://cdn.wickedcampers.com/nz/specials/whistler-special.jpg",
    });
    this.metaService.updateTag({ property: "og:image:height", content: "320" });
    this.metaService.updateTag({ property: "og:image:width", content: "611" });
    this.metaService.updateTag({
      property: "fb:app_id",
      content: "1450017568608709",
    });
    this.metaService.updateTag({
      property: "og:url",
      content: "https://www.wickedcampers.com",
    });
    this.metaService.updateTag({
      property: "og:description",
      content:
        "We offer Wicked campervan hire for budget traveller looking for a cheap and easy way of exploring World Wide.",
    });
    //app
    this.metaService.updateTag({
      property: "al:ios:app_name",
      content: "Wicked Campers",
    });
    this.metaService.updateTag({
      property: "al:android:package",
      content: "com.wickedcampers.android",
    });
    //this.loadbookdata();
    this.compareWith = this.compareWithFn;
  }
  loadPokemon() {
    this.pokeService.getCountry().subscribe((res) => {
      this.country = [...this.country, ...res];
    });
    this.pokeService.getVehicle(1).subscribe((res) => {
      this.mobil = res['results'];
    });
    this.pokeService.getLocation(1).subscribe((res) => {
      this.location =res['results'];
    });
    this.pokeService.getLocation().subscribe((res) => {
      this.alllocation = res['results'];
      const groupByCategory = this.alllocation.reduce((group, product) => {
        const { country } = product;
        group[country] = group[country] ?? [];
        group[country].push(product);
        return group;
      }, {});
      this.locationgroup=Object.keys(groupByCategory).map(function(k) { return groupByCategory[k] });
      console.log(this.locationgroup);
    });
    this.pokeService.getSpecials().subscribe((res) => {
      this.special = [...this.special, ...res];
    });
    this.pokeService.getKomen().subscribe((res) => {
      this.komen = [...this.komen, ...res];
    });
    
  }


  slideOpts = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },

    paginationClickable: true,
    observer: true,

    observeParents: true,
    breakpoints: {
      360: {
        slidesPerView: "auto",
        spaceBetween: 0,
        //scrollbar: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        freeMode: true,
      },
      640: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
        paginationClickable: true,
        watchSlidesProgress: true,
        pager: true,
        autoplay: false,
        //freeMode: true
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 15,
        paginationClickable: true,
        watchSlidesProgress: true,
        pager: true,
        autoplay: false,
        //freeMode: true
      },
    },
  };
  slideOptskom = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: false,
    speed: 900,
    lazy: true,
    paginationClickable: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      360: {
        slidesPerView: 2,
        spaceBetween: 0,
        //scrollbar: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
        paginationClickable: true,
        watchSlidesProgress: true,
        pager: true,
        freeMode: true,
      },
    },
  };
  slideOptsloc = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: false,

    lazy: true,
    speed: 900,
    paginationClickable: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      360: {
        slidesPerView: 2,
        spaceBetween: 0,
        //scrollbar: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 15,
        paginationClickable: true,
        watchSlidesProgress: true,
        pager: true,
        freeMode: true,
      },
    },
  };
  slideOpts1 = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    /* pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },*/
    lazy: true,
    speed: 900,
    paginationClickable: true,
    observer: true,
    observeParents: true,
    autoplay: false,
    loop: false,
    breakpoints: {
      360: {
        slidesPerView: 1,
        spaceBetween: 0,
        //scrollbar: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  };

  slidesDidLoad(slides: IonSlides) {
    //slides.startAutoplay();
  }
  async showModal() {
    const modal = await this.modalController.create({
      component: ModalPopupPage,
      componentProps: {
        name: "Hello User",
      },
    });
    return await modal.present();
  }
  async showModalx() {
    const modal = await this.modalController.create({
      component: IframePage,
      componentProps: {
        name: "Hello User",
      },
    });
    return await modal.present();
  }

  //bookings
  setdropdate() {
    var test = moment(this.step1m.pickupdate).add(7, "d").format();
    this.step1m.dropoffdate = test;
  }
  loadbookdata() {
    console.log(this.maxDate);
    this.pokeService.getRCMLocation("au").subscribe((res) => {
      this.booklocation = res["results"]["locations"];
      this.step1m["age"] = res["results"]["driverages"][0]["id"];
      let defaultid = "0";
      console.log(this.booklocation);
      var locparams = "";
      locparams = this.deflocval.replace("-", " ");
      var locx = this.titleCase(locparams);
      console.log("locparams:" + locx);
      this.booklocation.forEach(function (value) {
        if (locparams != "") {
          if (value["location"] == locx) {
            defaultid = value["id"];
          }
        } else {
          if (value["isdefault"] == true) {
            defaultid = value["id"];
          }
        }
      });
      if (defaultid != "0") {
        this.step1m.dropoffloc = defaultid;
        this.step1m.pickuploc = defaultid;
      }
      //console.log(JSON.stringify(this.booklocation));
      //console.log("age:"+this.step1['age']);
    });
    /*this.pokeService.getRCMAge('au').subscribe(res => {
      this.Age=res;
      this.step1['age'] =res[0]['id'];
      console.log("age:"+this.step1['age']);
    });*/
  }

  gotostep2m(form) {
    //this.step1m.pickupdate=moment(this.step1m.pickupdate).format("DD/MM/YYYY");
    //this.step1m.pickuptime=moment(this.step1m.pickuptime).format("HH:mm");
    //this.step1m.dropoffdate=moment(this.step1m.dropoffdate).format("DD/MM/YYYY");
    //this.step1m.dropofftime=moment(this.step1m.dropofftime).format("HH:mm");
    console.log(this.step1m);
    if (this.step1m.dropoffdate >= this.step1m.pickupdate) {
      let navigationExtras: NavigationExtras = {
        state: {
          data: this.step1m,
        },
      };
      this.router.navigate(["bookings-select-vehicles"], navigationExtras);
    }
  }
  @ViewChild("picker") picker;
  open() {
    this.picker.open();
  }

  titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }

  compareWithFn(o1, o2) {
    return o1 == o2;
  }
}
